module.exports = __webpack_public_path__ + "img/t-22981-001.2d557762.jpg";